import React from 'react';
import classNames from 'classnames';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons/faCalendarDay';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons/faCalendarCheck';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
// import useMakeStripeCheckout from '@buyside/util/hooks/useMakeStripeCheckout';

import {
  useCurrentUserEventRegistrationQuery,
  useEventRegistrationMutation
} from '@interfaces/graphql-typings';
// import { STRIPE_PLANS } from '@interfaces/payment/plans';

import styles from './eventRegistrationButtonStyles.scss';

const EventRegistrationButton: React.FC = () => {
  const {
    data: currentUserData,
    loading: currentUserLoading,
    error: currentUserError
  } = useCurrentUserEventRegistrationQuery();

  const [
    registerForEvent,
    { loading: registerForEventLoading, error: registerForEventError }
  ] = useEventRegistrationMutation({
    update(cache, { data }) {
      if (data?.createEventRegistration?.registered) {
        cache.modify({
          id: cache.identify({ id: currentUserData?.currentUser?.id, __typename: 'User' }),
          fields: { hasRegisteredForEvent: () => true }
        });
      }
    }
  });

  // const { onSubmit: eventCheckoutOnSubmit, loading: eventCheckoutLoading } = useMakeStripeCheckout(
  //   STRIPE_PLANS.event
  // );

  // const hasComplimentaryEventRegistration = Boolean(
  //   currentUserData?.currentUser?.hasComplimentaryEventRegistration
  // );
  const hasRegisteredForEvent = Boolean(currentUserData?.currentUser?.hasRegisteredForEvent);

  const onSubmit = (): void => {
    // if (hasComplimentaryEventRegistration) {
    registerForEvent();
    // } else {
    //   eventCheckoutOnSubmit();
    // }
  };

  if (currentUserError) throw currentUserError;
  if (registerForEventError) throw registerForEventError;

  return (
    <>
      <Button
        className={classNames(styles.registrationButton, {
          [styles.registered]: hasRegisteredForEvent
        })}
        disabled={hasRegisteredForEvent}
        faIcon={hasRegisteredForEvent ? faCalendarCheck : faCalendarDay}
        // isLoading={eventCheckoutLoading || registerForEventLoading || currentUserLoading}
        isLoading={registerForEventLoading || currentUserLoading}
        onClick={onSubmit}
        text={hasRegisteredForEvent ? 'Request Sent' : 'Join the Waitlist'}
        type={BUTTON_TYPES.PRIMARY}
      />
    </>
  );
};

export default EventRegistrationButton;
